<template>
    <div id="loading-bg-transparent" style="display: none;">
        <div class="loading-wrapper">
            <DecastAnimatedLogo/>
            <div class="loading-wrapper-title">
                <p id="loading-bg-transparent-title">Loading</p>
                <div id="btn-loader"></div>
            </div>
        </div>
    </div>
</template>

<script>
import DecastAnimatedLogo from './DecastAnimatedLogo.vue';
export default {
  components: {
    DecastAnimatedLogo,
  },
}
</script>

<style>
#loading-bg-transparent {
    width: 100%;
    height: 100%;
    background: #15161F70;
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    overflow: hidden;
    position: absolute;
    top: 0;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.loading-wrapper svg{
  height: 100px;
  width: 100px;
}
.loading-wrapper p {
  color: #FFFFFF;
  margin-top: 14px;
}
.loading-wrapper-title {
  display: flex;
  height: 50px;
}
#btn-loader {
  width: 30px;
  aspect-ratio: 8;
  transform: scale(.7);
  background: radial-gradient(circle closest-side, #FFFFFF 10%, #0000) 0/calc(100%/3) 100% space;
  clip-path: inset(0 100% 0 0);
  animation: l1 0.8s steps(4) infinite;
}

@keyframes l1 {
  to {
      clip-path: inset(0 -34% 0 0)
  }
}
</style>